"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WideMidfielderRoleBonuses = exports.WideMidfielderExpandedRoles = void 0;
// wideMidfielderRoles.ts
const playerBonuses_1 = require("../playerBonuses"); // Added import
const playerTraits_1 = require("../playerTraits");
const rarity_1 = require("../rarity");
const zones_1 = require("../zones");
const baseRoles_1 = require("./baseRoles");
var WideMidfielderExpandedRoles;
(function (WideMidfielderExpandedRoles) {
    // --- Uncommon --- GENERIC (Consistent with other positions)
    WideMidfielderExpandedRoles["RAPID_WIDE_MIDFIELDER"] = "RAPID_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["POWERFUL_WIDE_MIDFIELDER"] = "POWERFUL_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["TIRELESS_WIDE_MIDFIELDER"] = "TIRELESS_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["DETERMINED_WIDE_MIDFIELDER"] = "DETERMINED_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["HEROIC_WIDE_MIDFIELDER"] = "HEROIC_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["ECCENTRIC_WIDE_MIDFIELDER"] = "ECCENTRIC_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["RELIABLE_WIDE_MIDFIELDER"] = "RELIABLE_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["LUCKY_WIDE_MIDFIELDER"] = "LUCKY_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["TENACIOUS_WIDE_MIDFIELDER"] = "TENACIOUS_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["INSPIRATIONAL_WIDE_MIDFIELDER"] = "INSPIRATIONAL_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["DOMINANT_WIDE_MIDFIELDER"] = "DOMINANT_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["IMPACT_WIDE_MIDFIELDER"] = "IMPACT_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["PRESSING_WIDE_MIDFIELDER"] = "PRESSING_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["STUBBORN_WIDE_MIDFIELDER"] = "STUBBORN_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["VOCAL_WIDE_MIDFIELDER"] = "VOCAL_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["EXPERIENCED_WIDE_MIDFIELDER"] = "EXPERIENCED_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["FIREY_WIDE_MIDFIELDER"] = "FIREY_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["VERSATILE_WIDE_MIDFIELDER"] = "VERSATILE_WIDE_MIDFIELDER";
    // --- Uncommon --- WM SPECIFIC / FUNCTIONAL
    WideMidfielderExpandedRoles["PLAYMAKING_WIDE_MIDFIELDER"] = "PLAYMAKING_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["SHIELDING_WIDE_MIDFIELDER"] = "SHIELDING_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["ORCHESTRATING_WIDE_MIDFIELDER"] = "ORCHESTRATING_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["SILKY_WIDE_MIDFIELDER"] = "SILKY_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["STAR_WIDE_MIDFIELDER"] = "STAR_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["BOX_TO_BOX_WIDE_MIDFIELDER"] = "BOX_TO_BOX_WIDE_MIDFIELDER";
    // --- Rare --- GENERIC COMBINATIONS (Two basic traits)
    WideMidfielderExpandedRoles["ATHLETIC_WIDE_MIDFIELDER"] = "ATHLETIC_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["ENERGETIC_WIDE_MIDFIELDER"] = "ENERGETIC_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["VALIANT_WIDE_MIDFIELDER"] = "VALIANT_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["PLUCKY_WIDE_MIDFIELDER"] = "PLUCKY_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["ROBUST_WIDE_MIDFIELDER"] = "ROBUST_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["AGGRESSIVE_WIDE_MIDFIELDER"] = "AGGRESSIVE_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["GEGENPRESSING_WIDE_MIDFIELDER"] = "GEGENPRESSING_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["COMMANDING_WIDE_MIDFIELDER"] = "COMMANDING_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["ROUSING_WIDE_MIDFIELDER"] = "ROUSING_WIDE_MIDFIELDER";
    // --- Rare --- ARCHETYPAL WIDE MIDFIELDERS
    WideMidfielderExpandedRoles["WORKHORSE"] = "WORKHORSE";
    WideMidfielderExpandedRoles["CLASSIC_WIDE_MIDFIELDER"] = "CLASSIC_WIDE_MIDFIELDER";
    WideMidfielderExpandedRoles["DEFENSIVE_WIDE_MAN"] = "DEFENSIVE_WIDE_MAN";
    WideMidfielderExpandedRoles["SUPPORTING_FLANKER"] = "SUPPORTING_FLANKER";
    WideMidfielderExpandedRoles["POWER_RUNNER"] = "POWER_RUNNER";
})(WideMidfielderExpandedRoles || (exports.WideMidfielderExpandedRoles = WideMidfielderExpandedRoles = {}));
exports.WideMidfielderRoleBonuses = {
    [baseRoles_1.BaseRoles.WIDE_MIDFIELDER]: {
        rarity: rarity_1.Rarity.COMMON,
        statBlock: {
            run: playerBonuses_1.PlayerBonuses.MAIN_POSITION_ATTRIBUTE,
            pass: playerBonuses_1.PlayerBonuses.SECOND_POSITION_ATTRIBUTE,
            tackle: playerBonuses_1.PlayerBonuses.THIRD_POSITION_ATTRIBUTE,
        },
        positionsEnabled: [zones_1.Zones.DEFENSE, zones_1.Zones.MIDFIELD, zones_1.Zones.ATTACK], // Wide range of operation
        playerTraits: [],
    },
    // --- Uncommon --- GENERIC ---
    [WideMidfielderExpandedRoles.RAPID_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.RAPID],
    },
    [WideMidfielderExpandedRoles.POWERFUL_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Powerful runs down the flank
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.POWERFUL],
    },
    [WideMidfielderExpandedRoles.TIRELESS_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.STAMINA],
    },
    [WideMidfielderExpandedRoles.DETERMINED_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Determined effort/runs
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.DETERMINED],
    },
    [WideMidfielderExpandedRoles.HEROIC_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Heroic cross/assist
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.HERO],
    },
    [WideMidfielderExpandedRoles.ECCENTRIC_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Flair for dribbling
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.FLAIR],
    },
    [WideMidfielderExpandedRoles.RELIABLE_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Reliable delivery
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.RELIABLE],
    },
    [WideMidfielderExpandedRoles.LUCKY_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Lucky cross/assist
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.LUCKY],
    },
    [WideMidfielderExpandedRoles.TENACIOUS_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Tenacity in defence/winning ball
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.UNDERDOG],
    },
    [WideMidfielderExpandedRoles.INSPIRATIONAL_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Inspiring passes/crosses
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.INSPIRE],
    },
    [WideMidfielderExpandedRoles.DOMINANT_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Dominating the flank
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.DOMINANT],
    },
    [WideMidfielderExpandedRoles.IMPACT_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Sub providing pace/energy
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.SUPER_SUB],
    },
    [WideMidfielderExpandedRoles.PRESSING_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Winning ball high up
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.PRESSING], // Assuming PlayerTraits.PRESSING exists
    },
    [WideMidfielderExpandedRoles.STUBBORN_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Defensively solid
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.UNYIELDING],
    },
    [WideMidfielderExpandedRoles.VOCAL_WIDE_MIDFIELDER]: {
        // Added for Traditional FB (comment seems misplaced here, but keeping)
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Organising wide play/dictating tempo from flank
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.ORGANISED],
    },
    [WideMidfielderExpandedRoles.EXPERIENCED_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Wise decision-making in distribution/crossing
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.WISE],
    },
    [WideMidfielderExpandedRoles.FIREY_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.IGNITE],
    },
    [WideMidfielderExpandedRoles.VERSATILE_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // 3rd position attribute is tackle
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.VERSATILE],
    },
    // --- Uncommon --- WM SPECIFIC / FUNCTIONAL ---
    [WideMidfielderExpandedRoles.PLAYMAKING_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.PLAYMAKER],
    },
    [WideMidfielderExpandedRoles.SHIELDING_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Protecting ball, holding off challenges
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.SHIELD],
    },
    [WideMidfielderExpandedRoles.ORCHESTRATING_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.SHORT_PASS],
    },
    [WideMidfielderExpandedRoles.SILKY_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Good touch for carrying ball/dribbling
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.FIRST_TOUCH],
    },
    [WideMidfielderExpandedRoles.STAR_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Star influence via passing/creativity
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.STAR],
    },
    [WideMidfielderExpandedRoles.BOX_TO_BOX_WIDE_MIDFIELDER]: {
        parentRoles: [baseRoles_1.BaseRoles.WIDE_MIDFIELDER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.CHARGE],
    },
    // --- Rare --- GENERIC COMBINATIONS ---
    [WideMidfielderExpandedRoles.ATHLETIC_WIDE_MIDFIELDER]: {
        parentRoles: [
            WideMidfielderExpandedRoles.RAPID_WIDE_MIDFIELDER,
            WideMidfielderExpandedRoles.POWERFUL_WIDE_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [WideMidfielderExpandedRoles.ENERGETIC_WIDE_MIDFIELDER]: {
        parentRoles: [
            WideMidfielderExpandedRoles.RAPID_WIDE_MIDFIELDER,
            WideMidfielderExpandedRoles.TIRELESS_WIDE_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [WideMidfielderExpandedRoles.VALIANT_WIDE_MIDFIELDER]: {
        parentRoles: [
            WideMidfielderExpandedRoles.DETERMINED_WIDE_MIDFIELDER,
            WideMidfielderExpandedRoles.HEROIC_WIDE_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [WideMidfielderExpandedRoles.PLUCKY_WIDE_MIDFIELDER]: {
        parentRoles: [
            WideMidfielderExpandedRoles.LUCKY_WIDE_MIDFIELDER,
            WideMidfielderExpandedRoles.TENACIOUS_WIDE_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Plucky tackling/defensive effort
        positionsEnabled: [],
        playerTraits: [],
    },
    [WideMidfielderExpandedRoles.ROBUST_WIDE_MIDFIELDER]: {
        parentRoles: [
            WideMidfielderExpandedRoles.TENACIOUS_WIDE_MIDFIELDER,
            WideMidfielderExpandedRoles.POWERFUL_WIDE_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [WideMidfielderExpandedRoles.AGGRESSIVE_WIDE_MIDFIELDER]: {
        parentRoles: [
            WideMidfielderExpandedRoles.TENACIOUS_WIDE_MIDFIELDER,
            WideMidfielderExpandedRoles.RAPID_WIDE_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Aggressive closing down speed
        positionsEnabled: [],
        playerTraits: [],
    },
    [WideMidfielderExpandedRoles.GEGENPRESSING_WIDE_MIDFIELDER]: {
        parentRoles: [
            WideMidfielderExpandedRoles.PRESSING_WIDE_MIDFIELDER,
            WideMidfielderExpandedRoles.ORCHESTRATING_WIDE_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Pressing focus for stat bonus
        positionsEnabled: [],
        playerTraits: [],
    },
    [WideMidfielderExpandedRoles.COMMANDING_WIDE_MIDFIELDER]: {
        parentRoles: [
            WideMidfielderExpandedRoles.EXPERIENCED_WIDE_MIDFIELDER,
            WideMidfielderExpandedRoles.VOCAL_WIDE_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Wise and organised wide distribution/play
        positionsEnabled: [],
        playerTraits: [],
    },
    [WideMidfielderExpandedRoles.ROUSING_WIDE_MIDFIELDER]: {
        parentRoles: [
            WideMidfielderExpandedRoles.INSPIRATIONAL_WIDE_MIDFIELDER,
            WideMidfielderExpandedRoles.DETERMINED_WIDE_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Inspiring teammates through control/passing
        positionsEnabled: [],
        playerTraits: [],
    },
    // --- Rare --- ARCHETYPAL WIDE MIDFIELDERS ---
    [WideMidfielderExpandedRoles.WORKHORSE]: {
        parentRoles: [
            WideMidfielderExpandedRoles.TIRELESS_WIDE_MIDFIELDER,
            WideMidfielderExpandedRoles.TENACIOUS_WIDE_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Non-stop running
        positionsEnabled: [],
        playerTraits: [],
    },
    [WideMidfielderExpandedRoles.CLASSIC_WIDE_MIDFIELDER]: {
        parentRoles: [
            WideMidfielderExpandedRoles.RAPID_WIDE_MIDFIELDER,
            WideMidfielderExpandedRoles.PLAYMAKING_WIDE_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Emphasizing pace and getting wide
        positionsEnabled: [],
        playerTraits: [],
    },
    [WideMidfielderExpandedRoles.DEFENSIVE_WIDE_MAN]: {
        parentRoles: [
            WideMidfielderExpandedRoles.SHIELDING_WIDE_MIDFIELDER,
            WideMidfielderExpandedRoles.STUBBORN_WIDE_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [WideMidfielderExpandedRoles.SUPPORTING_FLANKER]: {
        parentRoles: [
            WideMidfielderExpandedRoles.RELIABLE_WIDE_MIDFIELDER,
            WideMidfielderExpandedRoles.ORCHESTRATING_WIDE_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [WideMidfielderExpandedRoles.POWER_RUNNER]: {
        parentRoles: [
            WideMidfielderExpandedRoles.POWERFUL_WIDE_MIDFIELDER,
            WideMidfielderExpandedRoles.BOX_TO_BOX_WIDE_MIDFIELDER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
};
